exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-uploader__drop-area[data-v-b2355e3c]{display:flex;flex-direction:column;justify-content:space-around;align-items:center;margin:1.5rem 0 2rem}.profile-uploader__drop-area--hover[data-v-b2355e3c]{opacity:.5}.profile-uploader__drop-text[data-v-b2355e3c]{margin-bottom:.5rem!important;font-size:1.125rem;text-align:center}", ""]);

// exports
